import {
 Popup,Field, CellGroup
} from "vant";

export const vantArr = [
  Popup,Field, CellGroup
];
